export default function getIsChecked(tableView, rowKey, lastDeliveryTimestamp) {
    if (!tableView) {
        return false;
    }
    if (tableView.isInVirtualSelectAllMode) {
        if (tableView.virutalSelectAllExclusionList.indexOf(rowKey) > -1) {
            return false;
        }
        // We use this timestamp to determine whether we are in virtual select all mode. So if we get a new item, it should not be a part of the selection, which is what the return below is checking
        if (tableView.selectAllModeTimeStamp) {
            return (new Date(lastDeliveryTimestamp).getTime() <
                tableView.selectAllModeTimeStamp.getTime());
        }
        return true;
    }
    return tableView.isInCheckedMode && tableView.selectedRowKeys.has(rowKey);
}
//# sourceMappingURL=getIsChecked.js.map